import { Card, Stack, Switch, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";

import { STATIONS } from "Constants/Stations";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { toggleVisibility as toggleStations } from "Redux/stationsSlice";
import { toggleVisibility } from "Redux/filtersSlice";
import { changeReportRightSideMode, changeShowReportLeftControl } from "Redux/sideSlice";

export default function RightSideItems() {
  const dispatch = useAppDispatch();

  const { reportRightSideMode } = useAppSelector((state) => state.side);
  const { visible } = useAppSelector((state) => state.stations);
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleClick = (key: string) => {
    dispatch(toggleVisibility(key));
  };

  const selectItem = (event: React.MouseEvent<HTMLElement>, newMode: number) => {
    if (newMode !== null) {
      dispatch(changeReportRightSideMode(Number(newMode)));
      if (Number(newMode) === 3) {
        dispatch(changeShowReportLeftControl(true));
      }
    }
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <ToggleButtonGroup value={Number(reportRightSideMode)} onChange={selectItem} exclusive aria-label="survay-show-type">
          <ToggleButton
            value={1}
            aria-label="item-1"
            style={{
              width: "80px",
              height: "56px",
              backgroundColor: Number(reportRightSideMode) === 1 ? "#4754CA" : "",
              color: Number(reportRightSideMode) === 1 ? "#fff" : "",
            }}
          >
            ایستگاه
          </ToggleButton>
          <ToggleButton
            value={2}
            aria-label="item-1"
            style={{
              width: "80px",
              height: "56px",
              backgroundColor: Number(reportRightSideMode) === 2 ? "#4754CA" : "",
              color: Number(reportRightSideMode) === 2 ? "#fff" : "",
            }}
          >
            برنامه حرکت
          </ToggleButton>
          <ToggleButton
            value={3}
            aria-label="item-1"
            style={{
              width: "80px",
              height: "56px",
              backgroundColor: Number(reportRightSideMode) === 3 ? "#4754CA" : "",
              color: Number(reportRightSideMode) === 3 ? "#fff" : "",
            }}
          >
            بلیط
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    </Card>
  );
}
